module.exports = __webpack_public_path__ + "img/List.52926017.svg";